import React, { ReactElement } from 'react';

// type SpinnerSize = 'normal' | 'large';

// interface Props {
//     size: SpinnerSize;
// }

// const sizeMap = {
//     normal: 24,
//     large: 32,
// };

function SpinnerIcon(): ReactElement {
    // const pixels = `${sizeMap[size]}`;
    return (
        // <svg
        // width="{pixels}"
        // height="{pixels}"
        //     viewBox="0 0 24 24"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        // >
        //     <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z" fill="black" />
        // </svg>

        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.0"
            width="26px"
            height="26px"
            viewBox="0 0 128 128"
            xmlSpace="preserve"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M63.9.45A63.46 63.46 0 1 1 .47 63.9 63.46 63.46 0 0 1 63.9.46zM41.8 19.38a22.27 22.27 0 1 1-22.3 22.27 22.27 22.27 0 0 1 22.27-22.27z"
                fill="#000000"
            />
            <g transform="translate(128,128) scale(-1.5,-1.5)">
                <circle cx="16" cy="64" r="16" fill="#00FF00" />
                <circle cx="16" cy="64" r="14.344" fill="#AAFF17" transform="rotate(45 64 64)" />
                <circle cx="16" cy="64" r="12.531" fill="#E1FF1D" transform="rotate(90 64 64)" />
                <circle cx="16" cy="64" r="10.75" fill="#FCEF1F" transform="rotate(135 64 64)" />
                <circle cx="16" cy="64" r="10.063" fill="#FDBA18" transform="rotate(180 64 64)" />
                <circle cx="16" cy="64" r="8.063" fill="#FD8111" transform="rotate(225 64 64)" />
                <circle cx="16" cy="64" r="6.438" fill="#FE530B" transform="rotate(270 64 64)" />
                <circle cx="16" cy="64" r="5.375" fill="#FF0000" transform="rotate(315 64 64)" />
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
                    calcMode="discrete"
                    dur="650ms"
                    repeatCount="indefinite"
                />
            </g>
        </svg>
    );
}

export default SpinnerIcon;
